import { createRoot } from 'react-dom/client'
import { Provider } from 'react-redux'
import { PersistGate } from 'redux-persist/integration/react'
import { preloadEmptyMascot } from '@teach/ui'
import { store, persistor } from '@/store'
import App from './App.tsx'
import { installEmDashTyping } from '@/lib/emDash'
import { installTranslateDomGuard } from '@/lib/translateDomGuard'
import './index.css'

preloadEmptyMascot()
// «--» → «—» во всех текстовых полях студии (см. `lib/emDash.ts`).
installEmDashTyping()
// Автоперевод браузера не должен ронить экран целиком (см. `lib/translateDomGuard.ts`).
installTranslateDomGuard()

createRoot(document.getElementById('root')!).render(
  <Provider store={store}>
    <PersistGate loading={null} persistor={persistor}>
      <App />
    </PersistGate>
  </Provider>,
)
